import { envConfig } from "@env/env-config";
import { BrowserType } from "../model/domain/browser-type";

export class BrowserChecker {

    public static lowVersionCheck() {
        const isMobile = BrowserChecker.mobileCheck();
        let ua: string = navigator.userAgent || navigator.vendor || window.opera;
        let nua = ua.toLowerCase();
        if (isMobile) {
            //*移动端的兼容提示处理
            switch (true) {
                case /micromessenger/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "micromessenger", /(micromessenger)\/([\d.]+)/, true);
                    break;
                case /ucbrowser/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "ucbrowser", /(ucbrowser)\/([\d.]+)/, true);
                    break;
                case /baiduboxapp/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "baiduboxapp", /(baiduboxapp)\/([\d.]+)/, true);
                    break;
                case /qqbrowser/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "qqbrowser", /(qqbrowser)\/([\d.]+)/, true);
                    break;
                case /firefox/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "firefox", /(firefox)\/([\d.]+)/, true);
                    break;
                case /opr/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "opr", /(opr)\/([\d.]+)/, true);
                    break;
                case /chrome/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "chrome", /(chrome)\/([\d.]+)/, true);
                    break;
                case /safari/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "safari", /(version)\/([\d.]+)/, true);
                    break;
            }
        } else {
            //*PC端的兼容提示处理 
            switch (true) {
                case !!window.ActiveXObject || "ActiveXObject" in window:
                    BrowserChecker.browserHint();
                    break;
                case /edg/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "edg", /(edg)\/([\d.]+)/, false);
                    break;
                case /firefox/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "firefox", /(firefox)\/([\d.]+)/, false);
                    break;
                case /opr/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "opr", /(opr)\/([\d.]+)/, false);
                    break;
                case /chrome/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "chrome", /(chrome)\/([\d.]+)/, false);
                    break;
                case /safari/i.test(nua):
                    BrowserChecker.versionsCheck(nua, "safari", /(version)\/([\d.]+)/, false);
                    break;
            }

        }
    }

    public static versionsCheck(nua: string, browserInfo: string, regex: RegExp, isMobile: boolean) {
        let browser = BrowserType[browserInfo];

        let find = regex.exec(nua);
        if (find && find[2]) {
            let match = parseFloat(find[2]);
            let minVersions: number = isMobile ? envConfig.getBrowserVersion(browser, "mobile") : envConfig.getBrowserVersion(browser, "pc");
            if (!minVersions || !(match >= minVersions)) {
                setTimeout(() => {
                    BrowserChecker.browserHint()
                }, 0)
            }
        }
    }

    public static browserHint() {
        window.qpAlertPrompt.warning("Browser incompatibility", "Please note, we have detected that you are currently running an unsupported browser. Please upgrade your browser to lastest version in order to use.");

        // localStorage.setItem('browserPrompt',String(new Date().getTime()))
        // if(window.noBrowserPrompt)
        // swal({
        //     title: "Browser incompatibility!",
        //     text: `
        //     <div>
        //         <p>Please note, we have detected that you are currently running an unsupported browser. Please upgrade your browser to lastest version in order to use.</p>
        //         <div>
        //             <input type="checkbox" name="browserPrompt" id="browserPrompt">
        //         </div>
        //     </div>
        //     `,
        //     html: true
        // });
    }


    /** 
     * @description 判断是为移动端设备
     * todo：当前处理情况 手机、ipad、微信, 屏幕小于 1152(在不兼容userAgent属性时) 都设置为 移动端
     */
    public static mobileCheck(): boolean {
        let isMobile: boolean = false;
        let ua = navigator.userAgent || navigator.vendor || window.opera;
        if (ua) {
            //*存在userAgent属性的时候判断方法
            //*todo：目前 包含 iPad 在在内，也算在移动端
            // 设备匹配正则
            const regexOne = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;// nosonar
            const regexTwo = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i// nosonar

            if (regexOne.test(ua) || regexTwo.test(ua.substr(0, 4))) {
                isMobile = true;
            } else if (/macintosh/i.test(ua) && window.innerWidth < 1152) {
                isMobile = true;
            } else if (window.innerWidth <= 1152) {
                isMobile = true;
            }
            //todo 判断移动端系统
            if (isMobile) {
                let nua = window.navigator.userAgent.toLocaleLowerCase();
                let isAndroid = /android/i.test(nua);
                let isIOS = /iphone|ipad|ipod|macintosh/i.test(nua);
            } else if (window.innerWidth <= 1152 || (typeof window.orientation !== 'undefined' && window.orientation !== 0 && window.orientation !== 180)) {
                isMobile = true;
            }
        } else if (window.innerWidth <= 1152 || (typeof window.orientation !== 'undefined' && window.orientation !== 0 && window.orientation !== 180)) {
            //*window.orientation 为旋转角度 ipad：90或 - 90横屏 ipad：0或180竖屏 Andriod：0或180横屏 Andriod：90或 - 90竖屏
            // todo :ipad的横屏处理 特殊 后期兼容 ipad时 添加处理
            //*不存在userAgent属性时的判断方法
            //*屏幕尺寸过小
            //*window.orientation属性用于获取屏幕的当前方向，只有移动设备才有这个属性，桌面设备会返回undefined
            isMobile = true;
        }
        return isMobile;
    }
}